import { Reducer } from 'redux';

import { isActionOfType } from '../../../utils/action.utils';

import * as types from './subscription-access.types';
import * as constants from './subscription-access.constants';

const initialState: types.ISubscriptionAccessState = null;

export const subscriptionAccessReducer: Reducer<types.ISubscriptionAccessState, types.ISubscriptionAccessAction> = (
  state = initialState,
  action,
) => {
  if (isActionOfType<types.IStoreSubscriptionAccess>(action, constants.STORE_SUBSCRIPTION_ACCESS)) {
    return action.payload;
  }

  if (isActionOfType<types.IClearSubscriptionAccess>(action, constants.CLEAR_SUBSCRIPTION_ACCESS)) {
    return initialState;
  }

  return state;
};
